import { Mark } from 'tiptap';

export default class HltMark extends Mark {
  get name() {
    return 'hlt';
  }
  get schema() {
    return {
      attrs: {
        class: {
          default: 'hlt',
        },
      },
      inclusive: false,
      parseDOM: [
        {
          tag: 'hlt',
          getAttrs: dom => ({
            class: dom.getAttribute('hlt'),
          }),
        },
      ],
      toDOM: node => [
        'hlt',
        {
          ...node.attrs,
        },
        0,
      ],
    };
  }
}
